module.exports = __webpack_public_path__ + "static/media/06-slider.a3f88c27.png";